import React, { useState, useEffect } from 'react';
import { getFirestore, doc, setDoc, collection, getDocs } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import './AjoutLoges.css';

interface DateItem {
  id: string;
  date: string;
}

function AjoutLoges() {
  const [formData, setFormData] = useState({
    nom: '',
    orient: '',
    date: '',
    jour: '',
    image: '',
    presentation: ''
  });

  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [dates, setDates] = useState<DateItem[]>([]);
  const navigate = useNavigate();

  const jours = [
    'Dimanche',
    'Lundi', 
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi'
  ];

  useEffect(() => {
    const fetchDates = async () => {
      const db = getFirestore();
      try {
        const datesSnapshot = await getDocs(collection(db, 'Date'));
        const datesData = datesSnapshot.docs.map(doc => ({
          id: doc.id,
          date: doc.data().date || doc.id
        }));
        setDates(datesData);
      } catch (error) {
        console.error('Erreur lors de la récupération des dates:', error);
      }
    };

    fetchDates();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const db = getFirestore();
      const storage = getStorage();
      let imageUrl = '';

      // Téléchargement de l'image si un fichier est sélectionné
      if (imageFile) {
        const imageRef = ref(storage, `loge_images/${formData.nom}/${imageFile.name}`);
        const snapshot = await uploadBytes(imageRef, imageFile);
        imageUrl = await getDownloadURL(snapshot.ref);
      }

      const logeRef = doc(db, 'Loges', formData.nom);
      await setDoc(logeRef, {
        nom: formData.nom,
        orient: formData.orient,
        date: formData.date,
        jour: formData.jour,
        image: imageUrl,
        presentation: formData.presentation
      });
      
      console.log('Loge ajoutée avec succès');
      navigate('/mapage/loges');
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la loge :', error);
      alert('Une erreur est survenue lors de l\'ajout de la loge.');
    }
  };

  return (
    <div className="ajout-loges-container">
      <h2>Créer une nouvelle loge</h2>
      <form onSubmit={handleSubmit} className="ajout-loges-form">
        <div className="form-group">
          <label>Nom de la Loge:</label>
          <input
            type="text"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            required
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label>Orient:</label>
          <input
            type="text"
            name="orient"
            value={formData.orient}
            onChange={handleChange}
            required
            className="form-input"
          />
        </div>

        <div className="date-container">
          <div className="form-group">
            <label>Date de Tenue:</label>
            <select
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              className="form-select"
            >
              <option value="">Sélectionner une date</option>
              {dates.map((date) => (
                <option key={date.id} value={date.id}>
                  {date.date}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Jour de Tenue:</label>
            <select
              name="jour"
              value={formData.jour}
              onChange={handleChange}
              required
              className="form-select"
            >
              <option value="">Sélectionner un jour</option>
              {jours.map((jour) => (
                <option key={jour} value={jour}>
                  {jour}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Image de la Loge:</label>
          <input 
            type="file" 
            accept="image/*" 
            onChange={handleImageChange} 
            className="form-input"
          />
          
          {imagePreview && (
            <div className="image-preview">
              <img 
                src={imagePreview} 
                alt="Aperçu de l'image" 
                style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px' }}
              />
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Présentation:</label>
          <textarea
            name="presentation"
            value={formData.presentation}
            onChange={handleChange}
            className="form-textarea"
            rows={10}
            placeholder="Entrez la présentation de la loge..."
          />
        </div>

        <button type="submit" className="submit-btn">
          Créer la loge
        </button>
      </form>
    </div>
  );
}

export default AjoutLoges;